import React from 'react'

const OFFER_CODE_VALIDATION_REGEX =
  /^(?:[0-9]{4}-[0-9]{2}-[0-9]{4}|[0-9]{4}-[0-9]{2}-[0-9]{4}R|[0-9]{4}-[0-9]{2}-[0-9]{4}r)$/

const SSN_VALIDATION_REGEX = /^[0-9]{4}$/

const ZIP_CODE_VALIDATION_REGEX = /(^\d{5}$)|(^\d{5}-(\d{4})?$)/

const PHONE_VALIDATION_REGEX = /^(\d{3})[- ]?(\d{3})[- ]?(\d{4})$/

const EMAIL_VALIDATION_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/

const TEXT_VALIDATION_REGEX = /\S{2,}/

export function getRequiredMessage(field) {
  return `${field.fieldLabel} is Required.`
}

export function isInputField(field) {
  return ['submit'].indexOf(field.fieldType) === -1
}

/*
 * Return an object that is used to validate the given field type, the object contains a
 * regex used to validate against the field value and an error message in case the
 * field is invalid
 *
 * @param [String] fieldName the name of the field used to generate the error message
 * @param [String] fieldType the type of the field it can be either ssn or offercode
 *
 * @return [Object]
 */
export function getFieldValidator(fieldName, fieldType) {
  const fieldValidator = {
    ssn: {
      regex: SSN_VALIDATION_REGEX,
      error: `${fieldName} must contain 4 Digits`
    },
    offercode: {
      regex: OFFER_CODE_VALIDATION_REGEX,
      error: `${fieldName} must match the requested format`
    },
    zipcode: {
      regex: ZIP_CODE_VALIDATION_REGEX,
      error: `Please enter a valid zip code`
    },
    phone: {
      regex: PHONE_VALIDATION_REGEX,
      error: `Please enter a valid phone number`
    },
    email: {
      regex: EMAIL_VALIDATION_REGEX,
      error: `Please enter a valid email`
    },
    text: {
      regex: TEXT_VALIDATION_REGEX,
      error: `Please enter a valid ${fieldName}`
    }
  }
  return fieldValidator[fieldType]
}

export function hasLabel(item) {
  let label
  if (item.fieldLabel !== 'Consent Checkbox') {
    label = (
      <label
        className="form__label label label--large"
        htmlFor={item.fieldLabel.toLowerCase().replace(/\s/g, '_')}
      >
        {item.fieldLabel}
      </label>
    )
  }
  return label
}

export function avoidValidation(item) {
  return item.fieldLabel === 'Unit'
}
